import { on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { ConsumersActions, AsyncActions } from './consumers.actions';
import { MenuBaseActions } from '../base/menu-base.actions';
import { LocationSetsActions } from '../location-sets/location-sets.actions';
import { LocationSetTypesActions } from '../location-set-types/location-set-types.actions';
import {Consumer} from '@emm/core/models/consumer.model';
import {asyncActionState, AsyncActionState} from '@emm/core/util/async-action-state';
import {withLoadables} from '@emm/core/util/ngrx.util';

export const consumerFeatureKey = 'consumer';

export interface ConsumerState extends EntityState<Consumer>, AsyncActionState {
    selectedTag: string | null;
}

export const adapter: EntityAdapter<Consumer> = createEntityAdapter<Consumer>({
    selectId: (item: Consumer) => item.tag,
    sortComparer: null
});

export const initialState: ConsumerState = adapter.getInitialState({
    selectedTag: null,
    ...asyncActionState.initial
});

const { loadActions, successActions, errorActions } = AsyncActions;

export const consumerReducer = withLoadables<ConsumerState>({
    loadActions,
    successActions,
    errorActions
})(
    initialState,

    on(MenuBaseActions.init, () => ({
        ...initialState,
    })),

    on(
        ConsumersActions.loadAll,
        ConsumersActions.reloadConsumers,
        LocationSetTypesActions.select,
        LocationSetsActions.select,
        (state: ConsumerState) => ({
            ...state,
            selectedTag: null
        })
    ),

    on(ConsumersActions.loadAllSuccess, (state: ConsumerState, { consumers }) =>
        adapter.setAll(consumers, state)
    ),

    on(ConsumersActions.select, (state: ConsumerState, { tag }) => ({
        ...state,
        selectedTag: tag
    })),

);
